'use strict';

var _ = require('lodash');
var BidPriceController = function BidPriceController($scope, $filter) {
  var rmMomentFormat = $filter('rmMomentFormat');
  $scope.departureDate = rmMomentFormat($scope.entityData.departureDateMoment, 'DATE_TIME_USER_SETTINGS');
  function createLegCabinLabel(legCabin) {
    var parts = legCabin.split('.'),
      leg = parts[0] + '-' + parts[parts.length - 2],
      cabin = parts[parts.length - 1];
    return {
      id: legCabin,
      label: leg + ' (' + cabin + ')',
      leg: leg,
      cabinCode: cabin
    };
  }
  function formatLegCabins(associatedLegCabins) {
    return _.map(associatedLegCabins, createLegCabinLabel);
  }
  $scope.legCabins = formatLegCabins($scope.entityData.associatedLegCabins);
  $scope.selectedLegCabin = $scope.legCabins[0];
};
BidPriceController.$inject = ['$scope', '$filter'];
module.exports = BidPriceController;